import { z } from "zod";

// Equipment count validation schema
export const equipmentCountSchema = z
	.number()
	.int("Count must be a whole number")
	.min(1, "Count must be at least 1")
	.max(9999, "Count cannot exceed 9999");

// Validation schema for create lab form
export const createLabSchema = z.object({
	name: z
		.string()
		.min(2, "Lab name must be at least 2 characters.")
		.max(100, "Lab name must be less than 100 characters.")
		.refine(value => !/[^a-zA-Z0-9\s]/.test(value), "Alphabets, numbers, and spaces are allowed only.")
		.refine(value => !/\d{4,}/.test(value), "Maximum 3 consecutive numbers allowed."),
	description: z.string().optional(),
	equipments: z.array(z.any()).optional(),
});
